import angular from 'angular';
import {  map } from 'lodash';
import '../../services/errors';
import '../../services/place';
import '../../services/area';
import { localStorage } from '../../utils';

const module = angular.module('whyline.modals.checkin-process', [
  'whyline.services.place',
  'whyline.services.area',
]);

const CheckinProcessModalController = (
  $scope,
  $translate,
  $uibModalInstance,
  $timeout,
  ErrorService,
  NotificationService,
  AreaService,
) => {
  'ngInject';
 
  $scope.areas = [];
  $scope.selectedArea;
  $scope.localArea =  localStorage.get('checkin-process');
  AreaService.GetAgendaAsPromise()
  .then(areas => {
    $timeout(() => {
      map(areas, area => $scope.areas.push({
        _id: area._id,
        label: area.label,
        type: area.type
      }));
    });
  })
  .catch(ErrorService.handler);


  $scope.close = () => {
    if (!$scope.selectedArea || !$scope.localArea) {
        return NotificationService.Warning($translate.instant('area_required'))
    }
    $uibModalInstance.close();
  };

  $scope.save = () => {
    if (!$scope.selectedArea) {
        return NotificationService.Warning($translate.instant('area_required'))
    }
    const area = JSON.parse($scope.selectedArea);
    localStorage.set('checkin-process', {label: area.label, _id: area._id});
    $uibModalInstance.close({label: area.label, _id: area._id});
  };
};

module.exports = module.controller(
  'CheckinProcessModalController',
  CheckinProcessModalController,
);